import React from "react";
import { InfoHoverPopover } from "../info-hover-popover";

export const DiscountPopover = () => (
  <InfoHoverPopover>
    <h2>Why buy discounted gift cards?</h2>
    <p>
      Buy discounted gift cards to save at your favorite stores. Use them to pay
      when you’re ready to checkout.
    </p>
    <hr />
    <h2>Who provides these discounted gift cards?</h2>
    <p>
      We source gift cards directly from merchants and from consumers like you.
      Because we are a marketplace, discounts and inventory often fluctuate.
    </p>
    <hr />
    <h2>Are discounted gift cards backed by GCX?</h2>
    <p>Yes, every card on GCX is covered by our 90 Day Money-Back Guarantee.</p>
  </InfoHoverPopover>
);
